export enum RTETools {
  TEXT_FORMAT,
  LIST_FORMAT,
  CLIPBOARD,
  HISTORY,
}
